module.exports = __webpack_public_path__ + "static/media/Jellyfish_7_t.59b89d07.jpg";